import { signIn } from "next-auth/react";

export async function sendSignInLink(toEmail: string, uniqueLoanId: string, origin?: string): Promise<void> {
  const urlParams = new URLSearchParams(window.location.search);
  const forceSendEmail = urlParams.get('force_send_email') || '';

  const isRedirectPath = uniqueLoanId.startsWith('/');
  let callbackUrl = isRedirectPath
    ? `${uniqueLoanId}${uniqueLoanId.includes('?') ? '&' : '?'}email=${encodeURIComponent(toEmail)}`
    : `/loanapp?email=${encodeURIComponent(toEmail)}&loanid=${encodeURIComponent(uniqueLoanId)}`;
  if (origin) {
    callbackUrl += `&origin=${encodeURIComponent(origin)}`;
  }
  if (forceSendEmail) {
    callbackUrl += `&force_send_email=${encodeURIComponent(forceSendEmail)}`;
  }
  await signIn('email', { email: toEmail, redirect: false, callbackUrl });
}